import React from 'react';
import classnames from 'classnames';
import { EditorState, Modifier, Entity, RichUtils, AtomicBlockUtils } from 'draft-js';
import { findLinkEntity, toggleLink } from 'lib/helpers';

export class BreakLinkButton extends React.Component {
	render() {
		const theme = this.props.theme;
		const editorState = this.props.store.getEditorState();
		const linkEntity = findLinkEntity(editorState);
		const disabled = !linkEntity;
		return (
			<div className={theme.buttonWrapper} onClick={e => e.stopPropagation()} title="移除超链接">
				<button
					className={classnames(theme.button, {
						[theme.disabled]: disabled,
					})}
					disabled={disabled}
					onClick={() => this.break()}>
					<i className="qa-ico-delete-link">断</i>
				</button>
			</div>
		);
	}

	break = () => {
		const { getEditorState, setEditorState } = this.props.store;
		toggleLink({ getEditorState, setEditorState, url: null });
	}
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/linkPlugin/BreakLinkButton.jsx